import { render, staticRenderFns } from "./PaginationPages.vue?vue&type=template&id=64ee2391&scoped=true"
import script from "./PaginationPages.vue?vue&type=script&lang=js"
export * from "./PaginationPages.vue?vue&type=script&lang=js"
import style0 from "./PaginationPages.vue?vue&type=style&index=0&id=64ee2391&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ee2391",
  null
  
)

export default component.exports